<template>
  <div class="relative-date-choser">
    <span class="title">
      {{$t('statistics.time_range')}}:
    </span>
    <div v-for="choice in choices" :key="choice" @click="choose(choice)" class="relative-date-choser-choice" :class="{'is-active': choice == date}">
      <span v-if="choice == 1">
        24 {{$t('statistics.hours')}}
      </span>
      <span v-else>
        {{choice}} {{$t('statistics.days')}}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['choices'],
  data(){
    return{
      date: Number
    }
  },
  methods: {
    choose(date){
      this.date = date
      this.$emit('change',date)
    }
  },
  mounted(){
    this.choose(this.choices[0])
  }
}
</script>
<style lang="scss">
.relative-date-choser{
  .title{
    margin-right: 10px;
    font-size: 1.5em;
  }
}
.relative-date-choser + h4{
  margin-top: 0;
}
.relative-date-choser-choice{
  display: inline-block;
  font-size: 16px;
  border-radius: 3px;
  border: 1px solid $paper;
  padding: 10px 15px;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  cursor: pointer;
  user-select: none;
  transition: all .5s ease;
  &:hover{
    background: $paper-dark;
    color: #fff;
  }
  &.is-active{
    border: 1px solid #e8f0fe;
    background: #e8f0fe;
    color: $sensual;
  }
}
</style>



// WEBPACK FOOTER //
// RelativeDateChoser.vue?1b5cbefa